export const TEMPLATE_LIBRARIES = {
  noaa_hssd_2026: {
    id: "noaa_hssd_2026",
    label: "NOAA HSSD 2026",
    standard: "S-57 + NOAA Extended Attributes",
    sourceUrl: "https://nauticalcharts.noaa.gov/publications/documents/HSSD_2026-0-00.pdf",
    notes: [
      "Based on HSSD 2026 sections 7.3, 17.x, and 19.0.",
      "Includes practical templates for common NOAA feature classes.",
    ],
    commonFields: [
      { key: "objectClass", type: "text", required: true, default: "S57_GENERIC" },
      { key: "descrp", type: "enum", required: true, default: 1, enum: [1, 2, 3, 4, 5] },
      { key: "SORIND", type: "text", required: true, default: "US,US,graph,H00000", noSpacesAfterComma: true },
      { key: "SORDAT", type: "date_yyyymmdd", required: true, default: "" },
      { key: "remrks", type: "text", required: false, default: "" },
      { key: "OBJNAM", type: "text", required: false, default: "" },
      { key: "images", type: "text", required: false, default: "" },
      { key: "asgnmt", type: "enum", required: false, default: 2, enum: [1, 2, 3] },
      { key: "prmsec", type: "enum", required: false, default: 1, enum: [1, 2, 3] },
      { key: "sftype", type: "enum", required: false, default: 3, enum: [1, 2, 3, 4, 5, 6] },
      { key: "acqsts", type: "enum", required: false, default: 2, enum: [1, 2] },
    ],
    classes: {
      S57_GENERIC: {
        label: "S-57 Generic",
        geometry: ["Point", "LineString", "Polygon"],
        fields: [],
      },
      OBSTRN: {
        label: "Obstruction",
        geometry: ["Point", "LineString", "Polygon"],
        fields: [
          { key: "CATOBS", type: "number", required: false, default: "" },
          { key: "VALSOU", type: "number", required: false, default: "" },
          { key: "HEIGHT", type: "number", required: false, default: "" },
          { key: "WATLEV", type: "enum", required: false, default: 3, enum: [2, 3, 4, 5] },
          { key: "QUASOU", type: "number", required: false, default: "" },
          { key: "TECSOU", type: "number", required: false, default: "" },
        ],
        rules: [
          { kind: "atLeastOne", keys: ["VALSOU", "HEIGHT"], message: "OBSTRN needs VALSOU or HEIGHT for most New/Update cases." },
        ],
      },
      UWTROC: {
        label: "Underwater Rock",
        geometry: ["Point", "Polygon"],
        fields: [
          { key: "VALSOU", type: "number", required: false, default: "" },
          { key: "WATLEV", type: "enum", required: false, default: 3, enum: [2, 3, 4, 5] },
          { key: "QUASOU", type: "number", required: false, default: "" },
          { key: "TECSOU", type: "number", required: false, default: "" },
        ],
      },
      WRECKS: {
        label: "Wreck",
        geometry: ["Point", "Polygon"],
        fields: [
          { key: "CATWRK", type: "number", required: true, default: 1 },
          { key: "VALSOU", type: "number", required: false, default: "" },
          { key: "HEIGHT", type: "number", required: false, default: "" },
          { key: "WATLEV", type: "enum", required: false, default: 3, enum: [2, 3, 4, 5] },
          { key: "QUASOU", type: "number", required: false, default: "" },
          { key: "TECSOU", type: "number", required: false, default: "" },
        ],
        rules: [
          { kind: "atLeastOne", keys: ["VALSOU", "HEIGHT"], message: "WRECKS should include VALSOU or HEIGHT." },
        ],
      },
      COALNE: {
        label: "Coastline",
        geometry: ["LineString", "Polygon"],
        fields: [
          { key: "CATCOA", type: "number", required: true, default: 1 },
        ],
      },
      LNDARE: {
        label: "Land Area / Islet",
        geometry: ["Point", "Polygon"],
        fields: [
          { key: "OBJNAM", type: "text", required: false, default: "" },
        ],
      },
      LNDELV: {
        label: "Land Elevation",
        geometry: ["Point"],
        fields: [
          { key: "ELEVAT", type: "number", required: true, default: 0 },
        ],
      },
      SOUNDG: {
        label: "Sounding",
        geometry: ["Point"],
        fields: [
          { key: "VALSOU", type: "number", required: true, default: 0 },
          { key: "QUASOU", type: "number", required: false, default: "" },
          { key: "TECSOU", type: "number", required: false, default: "" },
        ],
      },
      DEPARE: {
        label: "Depth Area",
        geometry: ["Polygon"],
        fields: [
          { key: "DRVAL1", type: "number", required: true, default: 0 },
          { key: "DRVAL2", type: "number", required: true, default: 10 },
        ],
      },
      LIGHTS: {
        label: "Light",
        geometry: ["Point"],
        fields: [
          { key: "COLOUR", type: "number", required: false, default: 1 },
          { key: "CATLIT", type: "number", required: false, default: 1 },
          { key: "VALNMR", type: "number", required: false, default: "" },
        ],
      },
      M_COVR: {
        label: "Meta Coverage",
        geometry: ["Polygon"],
        fields: [
          { key: "CATCOV", type: "number", required: true, default: 1 },
        ],
      },
    },
  },
  generic_s57: {
    id: "generic_s57",
    label: "Generic S-57",
    standard: "S-57 (minimal)",
    sourceUrl: "https://iho.int/en/s-57-standards-in-force",
    notes: ["Minimal schema for non-NOAA workflows."],
    commonFields: [
      { key: "objectClass", type: "text", required: true, default: "S57_GENERIC" },
      { key: "OBJNAM", type: "text", required: false, default: "" },
      { key: "INFORM", type: "text", required: false, default: "" },
    ],
    classes: {
      S57_GENERIC: {
        label: "S-57 Generic",
        geometry: ["Point", "LineString", "Polygon"],
        fields: [],
      },
      SOUNDG: {
        label: "Sounding",
        geometry: ["Point"],
        fields: [{ key: "VALSOU", type: "number", required: true, default: 0 }],
      },
      DEPARE: {
        label: "Depth Area",
        geometry: ["Polygon"],
        fields: [
          { key: "DRVAL1", type: "number", required: true, default: 0 },
          { key: "DRVAL2", type: "number", required: true, default: 10 },
        ],
      },
      COALNE: {
        label: "Coastline",
        geometry: ["LineString"],
        fields: [{ key: "CATCOA", type: "number", required: false, default: 1 }],
      },
      LIGHTS: {
        label: "Light",
        geometry: ["Point"],
        fields: [{ key: "COLOUR", type: "number", required: false, default: 1 }],
      },
    },
  },
};

export function sanitizeTemplateLibraryId(raw) {
  const id = String(raw || "").trim();
  return TEMPLATE_LIBRARIES[id] ? id : "noaa_hssd_2026";
}

export function getTemplateLibrary(id) {
  return TEMPLATE_LIBRARIES[sanitizeTemplateLibraryId(id)];
}

export function listTemplateLibraryOptions() {
  return Object.values(TEMPLATE_LIBRARIES).map((l) => ({ id: l.id, label: l.label }));
}
